import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { UserView } from '../components/SytemManagement/Users/UserView';
import { extractViewObjectFromNodeEdgeMapper } from '../data/daoFunctions/nodeEdgeMapperTransform';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const debug = process.env.REACT_APP_DEBUG && false;
/** Wraps UserView but only provides the context user */
const mapStateToProps = (state, ownProps) => {
    debug && console.log('UserView own props', ownProps);
    let viewObject = { matchedPrimary: undefined, matchedRelatedByPk: [], matchedRelatedBySk: [] };
    if (state.AppReducer.user) {
        const extractedViewObject = extractViewObjectFromNodeEdgeMapper(state.AppReducer.applicationData, state.AppReducer.user);
        if (extractedViewObject) {
            viewObject = extractedViewObject;
        }
    }
    const allowedActions = state.AppReducer.roleArbitrationInstance?.getSingleObjectControlActions('User');
    return {
        userGroupRoles: state.AppReducer.userGroupRoles,
        user: state.AppReducer.user,
        viewObject,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        applicationData: state.AppReducer.applicationData,
        contextCustomer: state.AppReducer.contextCustomer,
        isSmallView: state.AppReducer.isSmallView,
        allowedActions,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('UserView Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserView);
